import React from "react";
import {InlineLink, ListItem, SectionHeading, usePromotionsText} from "../PromotionsText";

const GeneralSection = () => {
  const {openLink} = usePromotionsText();

  return (
    <>
      <SectionHeading>General</SectionHeading>

      <ListItem marker="(a)">
        {"You may not assign or transfer any or all of Your rights or obligations under the Rules."}
      </ListItem>

      <ListItem marker="(b)">{"No third party shall have a right to enforce the Rules against Us."}</ListItem>

      <ListItem marker="(c)">
        {"Failure by Us to enforce a right under the Rules does not result in waiver of such right."}
      </ListItem>

      <ListItem marker="(d)">
        {"If any part of the Rules is found to be unenforceable as a matter of law, all other parts of the Rules shall be unaffected and shall remain in force."}
      </ListItem>

      <ListItem marker="(e)">
        {"Our determination and decision on all matters will be final and no correspondence will be entered into. Any dispute or situation not covered by the Rules will be resolved by Our management in a manner it deems to be the fairest to all concerned and, subject to the following subsection, that decision shall be final and binding on all players."}
      </ListItem>

      <ListItem marker="(f)">
        {"You and We agree that the laws of the state where Evenplay is permitted and licensed to offer sports wagering apply to the Rules and that any dispute between You and Us arising out of or in connection with the Rules or any Promotion will only be dealt with by the courts of that state."}
      </ListItem>

      <ListItem marker="(g)">
        {"If these Promotion Terms or any applicable Key Terms are translated into a language other than English, then the English version shall prevail where there is any inconsistency."}
      </ListItem>

      <ListItem marker="(h)" withBottomMargin>
        {"If You have any questions, please contact "}
        <InlineLink onPress={() => openLink('mailto:support@evenplay.com')}>{"support@evenplay.com"}</InlineLink>
        {"."}
      </ListItem>
    </>
  );
};

export default GeneralSection;
